<template>
	<v-container align-center>
		<v-layout justify-center>
			<v-flex>
				<v-layout justify-center row wrap>
					<v-flex>
						<v-autocomplete
							v-model="selectedYear"
							label="Select Year"
							:items="filterYears"
							:autcomplete="false"
							placeholder="Year"
							class="text-field-wrapper pt-4"
							clearable
						/>
					</v-flex>
					<v-flex>
						<v-autocomplete
							v-model="selectedMonth"
							label="Select Month"
							:items="filterMonths"
							:autcomplete="false"
							placeholder="Month"
							class="text-field-wrapper pt-4"
							clearable
						/>
					</v-flex>
				</v-layout>
				<v-flex class="pos-rel">
					<input
						ref="inputUpload"
						type="file"
						@change="onFileChange"
						required
						class="input"
						style="display: none"
					/>
				</v-flex>
				<v-layout justify-center>
					<v-btn
						round
						:dark="!!selectedYear && !!selectedMonth"
						:color="themeInputColor"
						:disabled="!selectedYear || !selectedMonth"
						:loading="isInvoiceFetching"
						@click="getInvoices"
					>
						Get Invoices
					</v-btn>
					<v-btn
						round
						:dark="true"
						:color="themeInputColor"
						:loading="isInvoiceUploading"
						@click="uploadInvoices"
					>
						Upload File
					</v-btn>
				</v-layout>
				<v-layout class="mt-4">
					<v-expansion-panel>
						<v-expansion-panel-content
							v-for="(item, i) in Object.keys(dstrSupportEntries)"
							:key="i"
						>
							<template v-slot:header>
								<div>
									{{
										dstrSupportEntries[item][0]
											.retailerName || "Unknown Name"
									}}
									|
									{{
										dstrSupportEntries[item][0].city ||
											"Unkown City"
									}}
									|
									{{
										dstrSupportEntries[item][0].state ||
											"Unknown State"
									}}
									|
									{{
										dstrSupportEntries[item][0].dstrId ||
											"Unknown Dstr ID"
									}}
								</div>
							</template>
							<v-data-table
								:headers="headers"
								:items="dstrSupportEntries[item]"
								class="elevation-1"
								:hide-actions="true"
							>
								<template v-slot:items="props">
									<tr @click="props.expanded = true">
										<td class="text-xs-center">
											{{ props.item.companyAmount }}
										</td>
										<td class="text-xs-center">
											{{ props.item.dstrAmount }}
										</td>
										<td class="text-xs-center">
											{{ props.item.executivePhoneNo }}
										</td>
										<td class="text-xs-center">
											{{ props.item.payOutDate }}
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-expansion-panel-content>
					</v-expansion-panel>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import { mapState } from "vuex";
import {
	UPLOAD_MEDIA_TO_SERVER,
	UPLOAD_DSTR_SUPPORT_INVOICE,
	FETCH_DSTR_SUPPORT_ENTRIES
} from "../../store/action-types";
import { THEME_INPUT_COLOUR, MONTHS, YEARS } from "../constants";

let filePayload = null;

export default {
	components: {},
	data() {
		return {
			MONTHS,
			YEARS,
			themeInputColor: THEME_INPUT_COLOUR,
			selectedMonth: "",
			selectedYear: "",
			isInvoiceFetching: false,
			isInvoiceUploading: false,
			uploadKey: "retailAdminDstrSupportInvoice",
			dstrSupportEntries: {},
			headers: [
				{
					text: "Company Amount",
					value: "companyAmount",
					align: "center",
					sortable: false
				},
				{
					text: "Distributor Amount",
					value: "dstrAmount",
					align: "center",
					sortable: false
				},
				{
					text: "Executive Phone No",
					value: "executivePhoneNo",
					align: "center",
					sortable: false
				},
				{
					text: "Payout Date",
					value: "payOutDate",
					align: "center",
					sortable: false
				}
			]
		};
	},
	computed: {
		...mapState({
			states: state => state.common.states
		}),
		filterYears() {
			// const currentYear = new Date().getFullYear();
			return [2021, 2022];
		},
		filterMonths() {
			return MONTHS;
		}
	},
	methods: {
		getInvoices() {
			if (this.isInvoiceFetching) {
				return;
			}
			this.isInvoiceFetching = true;
			this.$store
				.dispatch(FETCH_DSTR_SUPPORT_ENTRIES.dispatch, {
					month:
						MONTHS.findIndex(
							month => month === this.selectedMonth
						) + 1,
					year: this.selectedYear,
					baseToUse: "jeet11-retail"
				})
				.then(data => {
					if (Array.isArray(data)) {
						this.dstrSupportEntries = {};
					} else {
						this.dstrSupportEntries = data;
					}
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isInvoiceFetching = false;
				});
		},
		uploadInvoices() {
			this.clearInput();
			this.$refs.inputUpload.click();
		},
		uploadFilePath(filePath) {
			this.$store
				.dispatch(UPLOAD_DSTR_SUPPORT_INVOICE.dispatch, {
					fileUrl: filePath,
					baseToUse: "jeet11-retail"
				})
				.then(() => {})
				.catch(err => console.log(err))
				.finally(() => {
					this.isInvoiceUploading = false;
				});
		},
		clearInput() {
			this.$refs.inputUpload.value = "";
			this.payload = [];
		},
		onFileChange(e) {
			const files = e.target.files || e.dataTransfer.files;
			if (!files.length) return;
			filePayload = files[0];
			if (this.isInvoiceUploading) {
				return;
			}
			this.isInvoiceUploading = true;
			this.$store
				.dispatch(UPLOAD_MEDIA_TO_SERVER.dispatch, {
					key: this.uploadKey,
					file: filePayload,
					type: "csvUpload"
				})
				.then(data => {
					this.uploadFilePath(data.fileUrl);
				})
				.catch(err => console.log(err));
		}
	}
};
</script>

<style lang="scss"></style>
